<template>
  <el-table-column :label="label" :prop="prop" class-name="customer-name" :sortable="sortable" />
</template>

<script>
export default {
  components: {
  },
  props: {
    label: {
      type: String,
      default: '顧客名'
    },
    prop: {
      type: String,
      default: 'customer_name'
    },
    sortable: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">
.el-table {
  th,
  td {
    &.customer-name {
      width: 10em;
    }
  }
}
</style>
